{
    "common": {
        "mon": "จันทร์",
        "tue": "อังคาร",
        "wed": "พุธ",
        "thu": "พฤหัสบดี",
        "fri": "ศุกร์",
        "sat": "เสาร์",
        "sun": "อาทิตย์",
        "jan": "ม.ค.",
        "feb": "ก.พ.",
        "mar": "มี.ค.",
        "apr": "เม.ย.",        
        "jun": "มิ.ย.",
        "jul": "ก.ค.",
        "aug": "ส.ค.",
        "sep": "ก.ย.",
        "oct": "ต.ค.",
        "nov": "พ.ย.",
        "dec": "ธ.ค.",
        "january": "มกราคม",
        "february": "กุมภาพันธ์",
        "march": "มีนาคม",
        "april": "เมษายน",
        "may": "พฤษภาคม",
        "june": "มิถุนายน",
        "july": "กรกฎาคม",
        "august": "สิงหาคม", 
        "september": "กันยายน",
        "october": "ตุลาคม",
        "november": "พฤศจิกายน",
        "december": "ธันวาคม",
        "checkin": "เช็คอิน",
        "checkout": "เช็คเอาท์",
        "room": "ห้อง",
        "rooms": "ห้อง",
        "adult": "ผู้ใหญ่",
        "adults": "ผู้ใหญ่",
        "edit": "แก้ไข",
        "editCap": "แก้ไข",
        "delete":"ลบ",
        "deleteCap":"ลบ",
        "localTime": "เวลาท้องถิ่น",
        "back": "กลับ",
        "home": "หน้าแรก",
        "yes": "ใช่",
        "no": "ไม่",
        "left": "เหลือ",
        "hour": "ชั่วโมง",
        "hours": "ชั่วโมง",
        "night": "คืน",
        "nights": "คืน",
        "for": "สำหรับ",
        "why": "ทำไม",
        "get": "รับ",
        "more": "เพิ่มเติม",
        "agree": "ยอมรับ",
        "disagree": "ไม่ยอมรับ",
        "basedOn": "อ้างอิงจาก",
        "error": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
        "error2": "ล้มเหลว ลองใหม่อีกครั้ง!",
        "error3": "เกิดข้อผิดพลาด!!",
        "error4": "เกิดข้อผิดพลาด!! กรุณาลองใหม่อีกครั้ง",
        "error5": "ขออภัย!! เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
        "hi": "สวัสดี",
        "to": "ถึง",
        "free": "ฟรี",
        "per": "ต่อ",
        "at": "ที่",
        "day": "วัน",
        "days": "วัน",
        "time": "เวลา",
        "of": "ของ",
        "photo": "รูปภาพ",
        "photos": "รูปภาพ",
        "done": "เสร็จสิ้น",
        "fullStay": "พักเต็ม",
        "date": "วันที่",
        "and": "และ",
        "bookingDetail": "รายละเอียดการจอง",
        "Back": "กลับ",
        "Home": "หน้าแรก"
    },
    "userPopup":{
        "myAccount": "บัญชีของฉัน",
        "welcome": "ยินดีต้อนรับ",
        "user": "ผู้ใช้",
        "findMyBookings": "ค้นหาการจองของฉัน",
        "viewProfile": "ดูโปรไฟล์",
        "makeAReservarion": "ทำการจอง",
        "logout": "ออกจากระบบ",
        "loginCap": "เข้าสู่ระบบ",
        "login": "เข้าสู่ระบบ",
        "invalidCredentials": "ข้อมูลไม่ถูกต้อง",
        "invalidEmail": "อีเมลไม่ถูกต้อง",
        "passwordIsRequired": "ต้องใส่รหัสผ่าน",
        "minChar8":"ขั้นต่ำ 8 ตัวอักษร",
        "tooShort": "สั้นเกินไป!",
        "tooLong": "ยาวเกินไป!",
        "required": "จำเป็น",
        "emailInvalid":"ใส่อีเมลที่ถูกต้อง",
        "passwordInvalid":"ใส่รหัสผ่านที่ถูกต้อง",
        "phNumInvalid": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
        "signupCap": "สมัครสมาชิก",
        "signup": "สมัครสมาชิก",
        "verifyText":"ยืนยันว่าเป็นคุณ",
        "verifyText2":"เราได้ส่งรหัสยืนยันไปยังอีเมลของคุณ",
        "verificationCode":"รหัสยืนยัน",
        "didNotReceiveEmail": "ไม่ได้รับอีเมล",
        "clickToResend": "คลิกเพื่อส่งใหม่",
        "verifyAndSignIn": "ยืนยันและเข้าสู่ระบบ",
        "otpSentSuccessfully": "ส่ง OTP สำเร็จแล้ว",
        "somethingWentWrong":  "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
        "otpError": "กรุณาใส่ตัวเลขที่ถูกต้อง",
        "otpError2":"กรุณาใส่ตัวเลขเท่านั้น",
        "otpError3": "OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
        "otpError4": "OTP หมดอายุ คลิกส่งใหม่เพื่อลองอีกครั้ง",
        "otpError5": "กรุณาลองใหม่อีกครั้ง",
        "forgetPassword": "ลืมรหัสผ่าน",
        "submitError": "ผู้ใช้ไม่มีอยู่!",
        "userExistError": "ผู้ใช้นี้มีอยู่แล้ว",
        "checkYourEmail":  "ตรวจสอบอีเมลของคุณ",
        "passwordResetLinkSent": "เราได้ส่งลิงก์รีเซ็ตรหัสผ่านไปยัง",
        "noWorriesResetInstructions": "ไม่ต้องกังวล เราจะส่งคำแนะนำการรีเซ็ตให้คุณ",
        "enterYourEmail": "ใส่อีเมลของคุณ",
        "resetMyPassword": "รีเซ็ตรหัสผ่านของฉัน",
        "setANewPassword": "ตั้งรหัสผ่านใหม่",
        "newPassword": "รหัสผ่านใหม่",
        "confirmPassword": "ยืนยันรหัสผ่าน",
        "confirmPasswordError": "รหัสผ่านต้องตรงกัน",
        "backToLogin": "กลับไปเข้าสู่ระบบ",
        "dontHaveAccount": "ยังไม่มีบัญชี?",
        "alreadyHaveAccount": "มีบัญชีอยู่แล้ว?",
        "memberDiscount1": "คุณจะได้รับ",
        "memberDiscount2": "ส่วนลดสมาชิกตลอดไป",
        "discount1": "จัดการการจองทั้งหมดของคุณจากที่เดียว",
        "discount2": "สมัครสมาชิกเพื่อคำแนะนำส่วนบุคคลและประสบการณ์ที่ปรับแต่ง!!",
        "discount3": "เข้าร่วมชุมชนแขกที่พึงพอใจของเราและเริ่มวางแผนการพักของคุณ",
        "leftGridText1": "จัดการการจองทั้งหมดของคุณจากที่เดียว",
        "leftGridText2": "สมัครสมาชิกเพื่อคำแนะนำส่วนบุคคลและประสบการณ์ที่ปรับแต่ง!!",
        "leftGridText3": "เข้าร่วมชุมชนแขกที่พึงพอใจของเราและเริ่มวางแผนการพักของคุณ",
        "gridDiscountText1": "ส่วนลดสมาชิกสำหรับ",
        "gridDiscountText2": "โรงแรมที่เลือกตลอดไป",
        "gridDiscountText3": "เข้าสู่ระบบเพื่อประสบการณ์ที่ปรับแต่งตลอดไป",
        "gridDiscountText4": "รับสิทธิประโยชน์สมาชิกพิเศษ",
        "findBookingError": "อีเมลและรหัสการจองของคุณไม่ตรงกัน",
        "verifyAndConfirmBooking":"ยืนยันและยืนยันการจอง",
        "confirmEmailText": "เราได้ส่งรหัสยืนยันไปยังที่อยู่อีเมลของคุณ",
        "enterCodeText":"กรุณาใส่รหัสยืนยันที่ส่งให้คุณ",
        "didNotRecieveEmail": "ไม่ได้รับอีเมล?",
        "changeEmailText": "คลิกที่นี่เพื่อเปลี่ยนที่อยู่อีเมล",
        "verifyAndConfirm": "ยืนยันและยืนยัน",
        "verified": "ยืนยันแล้ว",
        "bookingExpired": "การจองหมดอายุ",
        "bookingExpiredText": "ขออภัย รหัสการจองที่คุณใช้หมดอายุแล้ว",
        "backToFindingBooking": "กลับไปค้นหาการจอง",
        "findMyBooking": "ค้นหาการจองของฉัน",
        "bookingEmail": "อีเมลการจอง",
        "reservationId": "รหัสการจอง",
        "findBooking": "ค้นหาการจอง",
        "abandonmentCartDoneText1": "ขอบคุณ!",
        "abandonmentCartDoneText2":"รายละเอียดตะกร้าของคุณได้ถูกส่งไปยังอีเมลแล้ว ดำเนินการจองของคุณได้ทุกเมื่อ",
        "Recommended Currencies": "สกุลเงินที่แนะนำ",
        "All currencies": "สกุลเงินทั้งหมด",
        "thisIsRequiredField": "นี่เป็นฟิลด์ที่จำเป็น"
    },
    "widget":{
        "destination": "จุดหมายปลายทาง",
        "enterDestination": "ใส่จุดหมายปลายทาง",
        "guests": "แขก",
        "nationality": "สัญชาติ",
        "selectNationality": "เลือกสัญชาติ",
        "nationalityIsRequired": "จำเป็นต้องระบุสัญชาติ",
        "selectedRate": "อัตราพิเศษ",
        "search": "ค้นหา",
        "ages": "อายุ",
        "orAbove": "หรือมากกว่า",
        "child": "เด็ก",
        "children": "เด็ก",
        "addAnotherRoom": "เพิ่มห้องอีกห้อง",
        "removeRoom": "ลบห้อง",
        "property": "โรงแรม",
        "city": "เมือง",
        "country": "ประเทศ",
        "bookNow": "จองเลย",
        "overnightStay": "พักค้างคืน",
        "dayUse": "ใช้ตอนกลางวัน",
        "destinationIsRequired": "ต้องใส่จุดหมายปลายทาง",
        "checkInIsRequired": "ต้องใส่วันที่เช็คอิน",
        "checkOutIsRequired": "ต้องใส่วันที่เช็คเอาท์",
        "noLocationFound": "ไม่พบสถานที่",
        "soldOut": "หมดแล้ว",
        "highDemand": "ความต้องการสูง",
        "dates": "วันที่",
        "allRates": "อัตราทั้งหมดเป็น",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "เช็คเอาท์ในวันเดียวกัน"
    },
    "promotion": {
        "headingText": "ข้อมูลสำคัญสำหรับ",
        "regularRate": "ไม่มี",
        "seniorCitizen": "อัตราผู้สูงอายุ",
        "agencyRate": "อัตราตัวแทน",
        "caaRate": "อัตรา CAA/AAA",
        "corporateRate": "อัตราธุรกิจ",
        "governmentRate": "อัตรารัฐบาล/ทหาร",
        "promotionalSpecialRate": "อัตราโปรโมชั่น/พิเศษ",
        "regularRateDescription": "ไม่มีการใช้โปรโมชั่น",
        "seniorCitizenRateDescription": "นี่เป็นอัตราโรงแรมลดราคาที่มีให้สำหรับผู้สูงอายุ โดยทั่วไปอายุ 60 ปีขึ้นไป",
        "agencyRateDescription": "นี่เป็นอัตราโรงแรมลดราคาที่เสนอให้และสามารถเข้าถึงได้ผ่านตัวแทนการเดินทางเฉพาะเท่านั้น เพื่อส่งเสริมความร่วมมือ",
        "caaRateDescription": "นี่เป็นอัตราโรงแรมพิเศษที่เสนอให้สมาชิก AAA หรือ CAA เพื่อการประหยัดพิเศษ",
        "corporateRateDescription": "นี่เป็นอัตราโรงแรมลดราคาที่ขยายให้กับนักเดินทางธุรกิจ โดยทั่วไปเจรจาระหว่างโรงแรมและองค์กรธุรกิจ",
        "governmentRateDescription": "แผนอัตรานี้เสนอส่วนลดเฉพาะสำหรับบุคลากรรัฐบาล/ทหารสำหรับการจองห้องโรงแรม",
        "contentSeniorCitizen": "ต้องมีหลักฐานวันเกิดในวันที่เช็คอิน การไม่แสดงบัตรประจำตัวที่เกี่ยวข้องจะทำให้ต้องเสียค่าโดยสารปกติ",
        "contentAgencyRate": "ต้องมีเอกสารยืนยันการจองและบัตรประจำตัวเมื่อมาถึง การไม่แสดงเอกสารเหล่านี้จะทำให้ต้องเสียอัตราปกติ",
        "contentPromotionalSpecialRate": "นี่เป็นอัตราโรงแรมลดราคาที่เสนอในช่วงเวลาจำกัด มักจะเชื่อมโยงกับกิจกรรม ฤดูกาล หรือแคมเปญการตลาดเฉพาะ",
        "contentCaaRate": "กรุณาแน่ใจว่าคุณมีบัตรสมาชิก CAA หรือบัตรประจำตัวที่เกี่ยวข้องในวันที่เช็คอิน การไม่แสดงบัตรประจำตัวที่เกี่ยวข้องจะทำให้ต้องเสียค่าโดยสารปกติ",
        "contentCorporateRate": "ต้องมีหลักฐานบัตรประจำตัวบริษัทหรือเอกสารทางการอื่นๆ ในวันที่เช็คอิน การไม่แสดงหลักฐานที่เกี่ยวข้องจะทำให้ต้องเสียค่าโดยสารปกติ",
        "contentGovernmentRate": "ต้องแสดงบัตรประจำตัวรัฐบาลหรือทหารที่ถูกต้องเมื่อเช็คอิน การไม่แสดงบัตรประจำตัวที่จำเป็นจะทำให้ต้องเสียค่าในอัตราปกติ",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "ใช้",
        "Offer Code": "รหัสข้อเสนอ",
        "Agency Code": "รหัสตัวแทน",
        "Corporate Code": "รหัสธุรกิจ",
        "All-Access Rate": "อัตราเข้าถึงทั้งหมด",
        "errorCode": "รหัสนี้ไม่ถูกต้อง"
    }
} 